<template>
  <a-modal
    :visible="visible"
    :title="file?.name || 'View Document'"
    width="900px"
    :destroy-on-close="true"
    @cancel="close"
  >
    <pdf-viewer v-if="file?.url" :file="file.url" :fullscreen-enabled="false" />

    <template #footer>
      <a-button @click="close">Close</a-button>
    </template>
  </a-modal>
</template>

<script>
import { Button, Modal } from 'ant-design-vue'
import PdfViewer from '@/components/entities/viewer/pdf-viewer.vue'

export default {
  components: {
    'a-button': Button,
    'a-modal': Modal,
    'pdf-viewer': PdfViewer
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    file: {
      type: Object,
      default: undefined
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
    }
  }
}
</script>
